import { Routes } from '@angular/router';
import {
  authorizationGuard,
  canMatchGuard,
} from './core/guards/authorization.guard';
import { nonAuthorizeGuard } from './core/guards/non-authorize.guard';
import { PermissionManagerService } from './core/services/permission-manager.service';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [nonAuthorizeGuard],
    loadComponent: () =>
      import('./features/login/login.page.component').then(
        (c) => c.LoginPageComponent
      ),
  },
  {
    // Public by-design (RGPD / Apple App Store account-deletion guideline).
    // Anyone can submit a deletion request via email; the backend is
    // responsible for sending a confirmation email to the account owner
    // before performing the actual deletion. Do NOT add an auth guard here.
    path: 'account-deletion',
    loadComponent: () =>
      import('./features/account-deletion/account-deletion.component').then(
        (c) => c.AccountDeletionComponent
      ),
  },
  {
    path: 'admin',
    canMatch: [canMatchGuard], // Recommend for lazyloading module by fire once (for initial navigation) (https://blog.jscrambler.com/how-to-auth-lazily-loaded-routes-in-angular)
    canActivate: [authorizationGuard], // It is a tips to fix the multiple check after the initial navigation
    providers: [PermissionManagerService],
    loadChildren: () =>
      import('./features/admin/admin.routes').then((m) => m.routes),
  },
  // Racine → /admin. Si non authentifié, l'authorizationGuard redirige
  // automatiquement vers /login (cf. core/guards/authorization.guard.ts).
  // Couvre aussi le cas du logout : après clear du token, l'utilisateur
  // arrive sur '/' → /admin → /login.
  { path: '', redirectTo: 'admin', pathMatch: 'full' },
  // Wildcard : route inconnue → page 404 dédiée (au lieu d'un redirect vers
  // login, qui masquait les vrais 404 et était trompeur).
  {
    path: '**',
    loadComponent: () =>
      import('./features/not-found/not-found.component').then(
        (c) => c.NotFoundComponent
      ),
  },
];
